import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { RespuestaAPI } from "src/interface/api-responses.model";
import { environment } from 'src/environments/environment';
import { Observable, Subject } from "rxjs";


const API = "https://admin.api.municipios.saion.mx";

@Injectable({
  providedIn: 'root'
})

export class Fraccion1Service{

  constructor(private http:HttpClient){}

  //---Observable para indicar URL de foto obtenida---
  urlFoto: any;
  private subject = new Subject<any>();
  url: string = API + "/";


  obtenerA82018(id: any, inciso: any, ano:any, carpeta:any, municipios:any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/docs/A8/${id}/${inciso}/${ano}/${carpeta}/${municipios}`);
  }

  obtenerA8MES(id: any, inciso: any, ano:any, mes:any, municipios:any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/docs/${id}/${inciso}/${ano}/${mes}/${municipios}`);
  }

  obtenerA8Carpeta(id: any, inciso: any, carpeta:any, municipios:any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/docs/A8/${id}/${inciso}/${carpeta}/${municipios}`);
  }
  obtenerA8año(id: any, inciso: any, ano:any, municipios:any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/doc/A8/ano/${id}/${inciso}/${ano}/${municipios}`);
  }
  obtenerAreas(id:any, inciso:any, ano:any, area:any, municipios:any){
    return this.http.get<RespuestaAPI>(API +`/municipios/areas/${id}/${inciso}/${ano}/${area}/${municipios}`);
  }
  obtenerarpetaMes(id: any, inciso: any, ano:any, mes:any, carpeta:any, municipios:any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/bienes/${id}/${inciso}/${ano}/${mes}/${carpeta}/${municipios}`);
  }

  obtenertrimestres(id: any, inciso: any, ano:any, area:any, carpeta:any, municipios:any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/docs/A86L/${id}/${inciso}/${ano}/${area}/${carpeta}/${municipios}`);
  }

  obtenerf13(id: any, inciso: any, area:any, carpeta:any, municipios:any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/docs/A813/${id}/${inciso}/${area}/${carpeta}/${municipios}`);
  }
  obtenerA152018(id: any, inciso: any, ano:any, carpeta:any, municipios:any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/dato/A15/${id}/${inciso}/${ano}/${carpeta}/${municipios}`);
  }
  obtenerA15MES(id: any, inciso: any, ano:any, mes:any, municipios:any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/A15/mes/${id}/${inciso}/${ano}/${mes}/${municipios}`);
  }

  obtenerA15Carpeta(id: any, inciso: any, carpeta:any, municipios:any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/dato/A15/${id}/${inciso}/${carpeta}/${municipios}`);
  }
  obtenerA15año(id: any, inciso: any, ano:any, municipios:any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/ano/${id}/${inciso}/${ano}/${municipios}`);
  }
  obtener15Areas(id:any, inciso:any, ano:any, area:any, municipios:any){
    return this.http.get<RespuestaAPI>(API +`/municipios/A15/${id}/${inciso}/${ano}/${area}/${municipios}`);
  }
  obtener15arpetaMes(id: any, inciso: any, ano:any, mes:any, carpeta:any, municipios:any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/A15/${id}/${inciso}/${ano}/${mes}/${carpeta}/${municipios}`);
  }

  obtener15trimestres(id: any, inciso: any, ano:any, area:any, carpeta:any, municipios:any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/docs/A15/${id}/${inciso}/${ano}/${area}/${carpeta}/${municipios}`);
  }

  obtenerf15(id: any, inciso: any, area:any, carpeta:any, municipios:any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/docs/A15/${id}/${inciso}/${area}/${carpeta}/${municipios}`);
  }

  obtenerNoticia(id: any, municipios:any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/obtenerNoticia/${id}/${municipios}`);
  }

  porPersona(id:any, anio: any, municipios:any){
    return this.http.get<RespuestaAPI>(API +`/municipios/fraccionV/${id}/${anio}/${municipios}`);
  }





















}
